import { useState, useContext, useCallback } from 'react';
import { NotificationContext } from 'shared/context/notificationContext';
import { LoaderContext } from 'shared/context/loaderContext';
import { useCm360Api } from '../../../shared/const/api-backend';
import { reportError } from 'shared/services/raygunService';

const useFetchMedicalScreening = () => {
  const [error, setError] = useState(null);
  const [medicalScreeningData, setMedicalScreeningData] = useState(null);
  const { showNotification } = useContext(NotificationContext);
  const { setLoading } = useContext(LoaderContext);
  const API = useCm360Api();

  const fetchMedicalScreeningData = useCallback(
    async (companionId) => {
      try {
        setLoading(true);
        const apiUrl = `/medical-screenings/${companionId}?filter=conditions`;
        const response = await API.get(apiUrl);
        setMedicalScreeningData(response.data);
        return response.data;
      } catch (error) {
        setError(error);
        showNotification('Error fetching medical screening data', 'error');
        reportError(error);
      } finally {
        setLoading(false);
      }
    },
    [showNotification],
  );

  return { medicalScreeningData, error, fetchMedicalScreeningData };
};

export default useFetchMedicalScreening;
